import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ProgramEditorV1 from './ProgramEditorV1';
import ProgramEditorV2 from './v2/ProgramEditorV2';
import axios from "../../utils/api/axios";

// Helper component to determine which editor to load
const ProgramEditorRouter = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    // Default to V1 unless we confirm it's V2 or new creation forced to V2
    const [version, setVersion] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const checkVersion = async () => {
            // If creating new program, check query param or default to V2 in future
            if (!id) {
                // Default to V2 for all new programs
                setVersion(2);
                setLoading(false);
                return;
            }

            try {
                // Use the v2 endpoint which supports architecture_version
                const response = await axios.get('/v2/programs', {
                    params: { id }
                });

                // The getPrograms endpoint returns { programs: [], count: 0 }
                const program = response.data?.programs?.[0];
                if (program && program.architecture_version === 2) {
                    setVersion(2);
                }
            } catch (error) {
                console.error("Failed to fetch program version", error);
            } finally {
                setLoading(false);
            }
        };

        checkVersion();
    }, [id, searchParams]);

    if (loading) return <div className="p-10 text-center">Loading Program Editor...</div>;

    if (version === 2) {
        return <ProgramEditorV2 />;
    }

    return <ProgramEditorV1 />;
};

export default ProgramEditorRouter;
